module.exports = __webpack_public_path__ + "img/réalisation de brise-vues.afd7ea91.jpg";